import React, { useState } from "react";
import { Box, Grid } from "@mui/material";
import { TextField, styled, Stack, Divider, Button } from "@mui/material";
import StoreHeader from "./StoreHeader";
import { IncrementBox, SubTitle, Text, TextIcrement, Title } from "./style";
import { CenterBox } from "../../components/styles";
import NoImgIcon from "../../images/item icon.svg";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import { useLocation, useHistory } from "react-router-dom";
import Repo from "../../Repository/Repo";
import ClipLoader from "react-spinners/ClipLoader";
import { Toast } from "../../components/components/Toast";

const ItemBox = styled(Box)({
  background: "#FFFFFF",
  padding: "16px 24px",
  display: "flex",
  flexDirection: "column",
  gap: "24px",
  borderRadius: "4px",
});

function MyCart() {
  const location = useLocation();
  const history = useHistory();
  const [state, setState] = useState({
    name: "",
    contact: "",
    address: "",
  });
  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState(location?.state?.items || []);

  const handleInput = (e) => {
    const { name, value } = e.target;
    setState((prev) => ({ ...prev, [name]: value }));
  };

  const handleCreate = async () => {
    try {
      setLoading(true);

      let { data } = await Repo.orders({
        request: {
          method: "saveOrder",
          data: {
            company_code: localStorage.getItem("companyCode"),
            subTotal: getCount(),
            total: getCount(),
            items: items,
            address: state,
          },
        },
      });
      setLoading(false);
      if (data.response.data.order) {
        Toast("success", "Order created successfully");
        history.push(`/store/${location.state.userName}`);
      } else {
        Toast("error", data.response.status.statusDescription);
      }
    } catch (err) {
      console.log("err:", err);
      setLoading(false);
    }
  };

  const handleRemove = (index) => {
    let copy = JSON.parse(JSON.stringify(items));
    copy.splice(index, 1);
    setItems(copy);
  };

  const increaseQty = (item) => {
    let copy = JSON.parse(JSON.stringify(items));
    let found = copy.find((i) => i._id == item._id);
    found.saleQuantity += 1;
    setItems(copy);
  };
  const decreaseQty = (item) => {
    if (item.saleQuantity) {
      let copy = JSON.parse(JSON.stringify(items));
      let found = copy.find((i) => i._id == item._id);
      found.saleQuantity -= 1;
      setItems(copy);
    }
  };

  const getCount = () => {
    let price = 0;
    items.forEach((item) => {
      if (item?.saleQuantity) {
        price += parseInt(item.price) * item.saleQuantity || 0;
      }
    });

    return price;
  };

  return (
    <Box sx={{ background: "#E8E8E8", py: "16px", px: "32px" }}>
      <StoreHeader
        title={location?.state?.storeName}
        userName={location?.state?.userName}
        address={location?.state?.address}
      />
      <Grid container spacing="24px" mt="1px" mb="16px">
        <Grid item md={6} xs={12}>
          <ItemBox>
            <Title sx={{ fontSize: "18px", fontWeight: 600 }}>
              Delivery Address
            </Title>
            <TextField
              fullWidth
              size="small"
              variant="outlined"
              label="Name"
              name="name"
              value={state.name}
              onChange={handleInput}
              sx={{ background: "#F6F6F6" }}
            />
            <TextField
              fullWidth
              size="small"
              variant="outlined"
              type="number"
              label="Phone"
              name="contact"
              value={state.contact}
              onChange={handleInput}
              sx={{ background: "#F6F6F6" }}
            />
            <TextField
              fullWidth
              size="small"
              variant="outlined"
              label="Address"
              name="address"
              value={state.address}
              onChange={handleInput}
              sx={{ background: "#F6F6F6" }}
            />
          </ItemBox>
        </Grid>
        <Grid item md={6} xs={12}>
          <ItemBox>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Title sx={{ fontSize: "18px", fontWeight: 600 }}>
                Order Summary
              </Title>
              <Title>Total {items?.length || 0} Items</Title>
            </Box>
            {items.map((item, i) => {
              return (
                <Box
                  key={i}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Stack direction="row" alignItems="center" spacing="8px">
                    <CenterBox
                      sx={{
                        height: "51px",
                        width: "51px",
                        borderRadius: "4px",
                        background: "#E8E8E8",
                      }}
                    >
                      <img
                        height="40px"
                        width="40px"
                        src={item?.imgURL ? item.imgURL : NoImgIcon}
                        alt=""
                      />
                    </CenterBox>
                    <Stack>
                      <Text>{item?.name}</Text>
                      <Text
                        sx={{
                          color: "#F14A4A",
                          fontWeight: 500,
                          display: "flex",
                        }}
                      >
                        <DeleteForeverIcon
                          sx={{
                            mr: "8px",
                            fontSize: "20px",
                            cursor: "pointer",
                          }}
                          onClick={() => handleRemove(i)}
                        />
                        Remove
                      </Text>
                    </Stack>
                  </Stack>

                  <IncrementBox>
                    <RemoveIcon
                      sx={{
                        cursor: "pointer",
                        fontSize: "18px",
                        color: "#332233",
                      }}
                      onClick={() => decreaseQty(item)}
                    />
                    <TextIcrement>{item?.saleQuantity || 0}</TextIcrement>

                    <AddIcon
                      sx={{
                        cursor: "pointer",
                        fontSize: "18px",
                        color: "#332233",
                      }}
                      onClick={() => increaseQty(item)}
                    />
                  </IncrementBox>
                </Box>
              );
            })}
          </ItemBox>
        </Grid>
      </Grid>
      <Grid container py="24px" sx={{ background: "#FFFFFF" }}>
        <Grid item md={5.5} xs={12}>
          <ItemBox sx={{ gap: "8px" }}>
            <Title sx={{ fontSize: "18px", fontWeight: 600 }}>
              Price Details
            </Title>
            <Stack direction="row" width="100%" justifyContent="space-between">
              <Text>Sub Total</Text>
              <Text>Rs {getCount()}</Text>
            </Stack>
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Text>Discount</Text>
              <Text>Rs 00.0</Text>
            </Box>
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Text>Delivery Charges</Text>
              <Text>Rs 00.0</Text>
            </Box>
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Text>Tax</Text>
              <Text>Rs 00.0</Text>
            </Box>
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Title sx={{ fontSize: "18px" }}>To Pay</Title>
              <Title sx={{ fontSize: "18px" }}>Rs {getCount()}</Title>
            </Box>
          </ItemBox>
        </Grid>
        <Grid
          item
          md={1}
          xs={12}
          sx={{
            display: {
              xs: "none",
              sm: "none",
              md: "flex",
              justifyContent: "center",
            },
          }}
        >
          <Divider orientation="vertical" />
        </Grid>
        <Grid
          item
          md={5.5}
          xs={12}
          sx={{ pr: "40px", display: "flex", alignItems: "center" }}
        >
          {loading && (
            <Stack width="100%" alignItems="center" justifyContent="center">
              <ClipLoader size={80} color="#4DAF51" loading={true} />
            </Stack>
          )}
          {!loading && (
            <Stack width="100%">
              <Button
                fullWidth
                variant="contained"
                sx={{ textTransform: "none", height: "48px" }}
                onClick={handleCreate}
              >
                <DoneAllIcon
                  sx={{ color: "#fff", fontSize: "26px", ml: "-24px" }}
                />
                <Stack>
                  <Text sx={{ fontWeight: 600, color: "#fff" }}>
                    Place Order
                  </Text>
                  <SubTitle sx={{ color: "#fff" }}>(Cash on delivery)</SubTitle>
                </Stack>
              </Button>
              <Button
                fullWidth
                variant="contained"
                sx={{
                  mt: 2.4,
                  background: "#D66A6A !important",
                  textTransform: "none",
                  height: "48px",
                }}
              >
                <Text sx={{ fontWeight: 600, color: "#fff" }}>
                  Cancel Order
                </Text>
              </Button>
            </Stack>
          )}
        </Grid>
      </Grid>
    </Box>
  );
}

export default MyCart;
